import { TRootState } from 'Redux/Reducers';

export const getEnteredCouponCode = (state: TRootState) => state.payment.couponCode || '';
